import React, { Component } from "react";
import { Dimensions } from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Input from '@material-ui/core/Input';
import TextField from '@material-ui/core/TextField';

class EditorSegments extends Component {
	constructor(props) {
		super(props);
		this.nameRef = React.createRef();
		this.handleKey = this.handleKey.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onDragEnter = this.onDragEnter.bind(this);
		this.onSelect = this.onSelect.bind(this);
		this.generaTextEditor = this.generaTextEditor.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.tagsOK = this.tagsOK.bind(this);
		this.resaltaNextTag = this.resaltaNextTag.bind(this);
		this.selectorTipusSegClick = this.selectorTipusSegClick.bind(this);
		this.cercaTagEnPos=this.cercaTagEnPos.bind(this);
		this.cercaTagEnCurrentPos=this.cercaTagEnCurrentPos.bind(this);
		this.cercaTagEnCurrentSelection=this.cercaTagEnCurrentSelection.bind(this);
		this.seleccionaTag=this.seleccionaTag.bind(this);
		this.deseleccionaTag=this.deseleccionaTag.bind(this);
		this.pintaSelectorTipusSeg=this.pintaSelectorTipusSeg.bind(this);
		this.traspassaSegment=this.traspassaSegment.bind(this);
		this.nextTipusSeg=this.nextTipusSeg.bind(this);
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
		
		// Estat
		this.state={
			tipusSeg: "trg",
			width: 0,
			height: 0
		}
		this.nouSegment=1;
		this.nextTag=0;
		
		// Gestio TAG seleccionat
		this.arrastraTag=-1;
		this.indexTagSeleccionat=-1;
		this.arrastranTagFase=-1;
		
		// SPACEBAR quan CaractersInvisibles
		this.caretPos=-1;
	}
	
	updateWindowDimensions(){
		this.setState({ width: window.innerWidth, height: window.innerHeight });
	}
	
	componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
	}
	
	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
	}

	// Gestio de TAGs	
	tagsOK(){
//		console.log("tagsOK: "+this.nextTag);
		var trobat=false;
		while(this.nextTag < this.props.segment["trg"].tags.length && trobat==false){
			if(this.calMostrarTag(this.nextTag)){
				trobat=true;
			}else{
				this.nextTag++;
			}
		}
//		console.log("tagsOK trobat: "+trobat+" | "+this.nextTag);
		return !trobat;
	}
	
	resaltaNextTag(e){
		let text=e.target.value;
		let i=1;
		let trobat=false;
		//console.log("resaltaNextTag["+this.nextTag+"]: "+text);
		while(i<(text.length) && !trobat){
			if ( (text.charAt(i)==">") && (this.cercaTagEnPos(text, i)==this.nextTag)){
				trobat=true;
			}
			i++;
		}
		this.nextTag++;
	}
	
	cercaTagEnCurrentPos(text){
//		console.log("cercaTagEnCurrentPos");
		let ret = this.cercaTagEnPos(text, this.nameRef.current.selectionStart);
		if(ret==-1){
			ret = this.cercaTagEnPos(text, this.nameRef.current.selectionEnd);
		}
		return ret;
	}
	
	cercaTagEnPos(text, pos){
		let inici=0;
		let fi=0;
		let trobat=false;
		let stop=false;
		//console.log("cercaTagEnPos "+pos);
		while(inici<5 && !trobat && !stop && pos-inici>0){
			inici++;
			//console.log("cercaTagEnPos i["+inici+"]");
			if(text.charAt(pos-inici)=="<"){
				trobat=true;
			}else if(text.charAt(pos-inici)==">"){
				stop=true;
			}
		}
		if(trobat){
			trobat=false;
			while(fi<4 && !trobat && text.length>pos+fi){
				//console.log("cercaTagPos f["+fi+"]");
				if(text.charAt(pos+fi)==">"){
					trobat=true;
				}
				fi++;
			}
			if(trobat){
				//console.log("cercaTagEnPos TROBAT: "+(pos-inici+0)+", "+(pos+fi+0));
				return this.seleccionaTag(text, pos-inici, pos+fi);
			}
		}
		return -1;
	}
	
	cercaTagEnCurrentSelection(text){
		//console.log("cercaTagEnCurrentSelection");
		if((text.length>this.nameRef.current.selectionStart) && (text.charAt(this.nameRef.current.selectionStart)=="<") && (text.charAt(this.nameRef.current.selectionEnd-1)==">") ){
			return this.seleccionaTag(text, this.nameRef.current.selectionStart, this.nameRef.current.selectionEnd);
		}
		return -1;
	}
	
	seleccionaTag(text, inici, fi){
		//console.log("seleccionaTag("+text+","+inici+","+fi+")");
		let tagSel=-1;
		if(inici>-1 && !(fi>text.length)){
			tagSel = parseInt(text.substring(inici+1, fi),10);
			if (isNaN(tagSel)){
				this.indexTagSeleccionat = tagSel = -1;
			}else{
				this.nameRef.current.selectionStart=inici;
				this.nameRef.current.selectionEnd=fi;
				this.indexTagSeleccionat = tagSel;
			}
			this.props.onSeleccionaTag(this.indexTagSeleccionat);
		}
		//console.log("seleccionaTag: "+tagSel);
		return tagSel;
	}
	
	deseleccionaTag(){
		if(this.indexTagSeleccionat !== -1){
			//console.log("deseleccionaTag");
			this.indexTagSeleccionat = -1;
			this.props.onSeleccionaTag(-1);
		}
	}
	
	onDragEnter(e){
		if(this.indexTagSeleccionat > -1){
			this.arrastranTagFase=2;
		}
	}
	
	componentDidUpdate() {
		if(this.nouSegment==1 && this.nameRef.current!=null){
			this.nameRef.current.select();
			this.nouSegment=0;
			this.nextTag=0;
		}
	}
	
	onSelect(e){
		if(this.cercaTagEnCurrentSelection(e.target.value)==-1){
			if(this.cercaTagEnCurrentPos(e.target.value)==-1){
				this.deseleccionaTag();
			}
		};
	}
	
	nextTipusSeg(){
		//console.log("nextTipusSeg");
		let nextTipus = this.state
		let trobat=false;
		let i=0;
		for (var key in this.props.segment){
			if(i==0 || trobat){
				nextTipus=key;
			}
			if(key===this.state.tipusSeg){
				trobat=true;
			}else{
				trobat=false;
			}
			i++;
		}
		this.setState(
			{tipusSeg: nextTipus}
		);
	}
	
	traspassaSegment(){
		//console.log("traspassaSegment");
//		let lastOrder=0;
		this.props.segment["trg"].text=this.props.segment[this.state.tipusSeg].text;
		for(let i=0; i<this.props.segment["trg"].tags.length; i++){
			if(this.props.segment[this.state.tipusSeg].tags.length>i){
				this.props.segment["trg"].tags[i].position=this.props.segment[this.state.tipusSeg].tags[i].position;
				this.props.segment["trg"].tags[i].order=i;
//				this.props.segment["trg"].tags[i].order=this.props.segment[this.state.tipusSeg].tags[i].order;
//				lastOrder=this.props.segment[this.state.tipusSeg].tags[i].order;
			}else{
//				lastOrder++;
				this.props.segment["trg"].tags[i].position=this.props.segment["trg"].text.length;
				this.props.segment["trg"].tags[i].order=i;
			}
		}
		this.setState(
			{tipusSeg: "trg"}
		);
		this.nouSegment=1;
		this.nextTag=0;
		/*----------------*/
		let lstSegmentsMod=this.props.segment;
		lstSegmentsMod["trg"]=this.props.segment["trg"];
		this.props.updateSegment(lstSegmentsMod, this.props.index);
		/*----------------*/
	}
	
	handleClick(e){
//		console.log("handleClick");
//		if(this.cercaTagEnCurrentPos(e.target.value)<0){
//			this.deseleccionaTag();
//		};
	}
	
	handleChange(e) {
//		console.log("------------- [handleChange:"+e.target.value+"]------------------------");
		let text=e.target.value;
		let textFinal="";
		let strlen=0;
		var esTag;
		let segmentMod=this.props.segment["trg"];
//		console.log("handleChange INICI [segmentMod]:");
//		console.log(segmentMod);
		
		//if(this.state.tipusSeg==="trg"  && this.props.showInvChars===0){
		if(this.state.tipusSeg==="trg"){
//			console.log("Arrastrant tag ["+this.indexTagSeleccionat+"]");
//			console.log("Tracte Tags");
			let lstTagsTractats=this.props.segment["src"].tags.map(() => false);
			var itag;
			var i;
			for(let j=0; j<text.length; j++){
				esTag=false;
				if(text.charAt(j)=="<"){
					let trobat=false;
					i = 1;
					while((i+j)<(text.length) && i<4 && !trobat){
						//console.log("(i,j): ("+i+","+j+"): ["+text.charAt(j+i)+"]");
						if (text.charAt(j+i)==">"){
							esTag=true;
							trobat=true;
							for(let k=j+1; k<j+i; k++){
								//console.log("k: "+k);
								if(isNaN(text.substring(k, k+1)) || (this.props.showInvChars===0 && (text.substring(k, k+1)===" " || text.substring(k, k+1)==="\t")) 
																|| (this.props.showInvChars!==0 && (text.substring(k, k+1)==="·" || text.substring(k, k+1)==="\u2192"))){
									//console.log("isNaN: ["+text.substring(k, k+1)+"]");
									esTag=false;
								}else{
									//console.log("number: "+text.substring(k, k+1));
								}
							}
							if(esTag){
//								console.log("text.substring(j+1, j+i): ("+(j+1)+","+(j+i)+") ["+text.substring(j+1, j+i)+"]");
								itag=parseInt(text.substring(j+1, j+i), 10);
							}
						}else{
							i++;
						}
					}
				}
				if(!esTag){
//					console.log("["+j+"] caracter "+text.charAt(j)+" en strlen "+strlen);
					textFinal+=text.charAt(j);
					strlen++;
				}else{
//					console.log("["+j+"] esTag "+itag);
					if(!lstTagsTractats[itag]){
						segmentMod.tags[itag].position=strlen;
						//console.log("handleChange [segmentMod]: "+JSON.stringify(segmentMod));
						lstTagsTractats[itag]=true;
						j+=i;
					}else{
//						console.log("El tag ["+text.charAt(j+1)+"] ja s'ha tractat");
					}
				}
//				console.log("textFinal_a1:"+textFinal);
			}
			
			//Manté elements extrems als extrems
			for(let i=0; i<segmentMod.tags.length; i++){
				if(!lstTagsTractats[i] && this.props.simplificaTags && (this.props.segment["src"].tags[i].position==this.props.segment["src"].text.length) && (segmentMod.tags[i].position==segmentMod.text.length)){
					//console.log("handleChange coloca tag "+i+" al final perque es extrem");
					//console.log("handleChange [segmentMod]: "+JSON.stringify(segmentMod));
					segmentMod.tags[i].position=textFinal.length;
					lstTagsTractats[i]=true;
					//console.log("handleChange [segmentMod]: "+JSON.stringify(segmentMod));
				}else if(!lstTagsTractats[i] && this.props.simplificaTags && (this.props.segment["src"].tags[i].position==0) && (segmentMod.tags[i].position==0)){
					//console.log("handleChange coloca tag "+i+" al principi perque es extrem");
					//console.log("handleChange [segmentMod]: "+JSON.stringify(segmentMod));
					segmentMod.tags[i].position=0;
					lstTagsTractats[i]=true;
					//console.log("handleChange [segmentMod]: "+JSON.stringify(segmentMod));
				}
			}
		
			for(let i=0; i<segmentMod.tags.length; i++){
//				console.log("lstTagsTractats["+i+"] ["+lstTagsTractats[i]+"]");
				if(!lstTagsTractats[i] && this.nameRef!=null && this.nameRef.current!=null){
					//console.log("handleChange coloca tag "+i+" al principi, perque no sha tractat");
					//console.log("handleChange coloca tag "+i+" al caretPosition, perque no sha tractat");
					segmentMod.tags[i].position = (this.nameRef.current.selectionEnd > this.nameRef.current.selectionStart) ? this.nameRef.current.selectionStart : this.nameRef.current.selectionEnd;
					//segmentMod.tags[i].position = segmentMod.tags[i].position>i*3 ?  segmentMod.tags[i].position-(i*3):0;
					lstTagsTractats[i]=true;
				}
			}
			
			if(this.arrastranTagFase>0){
				this.arrastranTagFase--;
				if(this.arrastranTagFase==0){
					this.indexTagSeleccionat=-1;
				}
			}
			if(this.props.showInvChars>0){
				//segmentMod.text=text.replace(/·/g," ").replace(/\u2192/g,"\t");
				segmentMod.text=textFinal.replace(/·/g," ").replace(/\u2192/g,"\t");
			}else{
				segmentMod.text=textFinal;
			}
			let lstSegmentsMod=this.props.segment;
			lstSegmentsMod["trg"]=segmentMod;
//			console.log("handleChange FI [segmentMod]:");
//			console.log(segmentMod);
			this.props.updateSegment(lstSegmentsMod, this.props.index);
		}
	}
	
	handleKey(e){
		// TAB
		//-------------------
		if (e.keyCode === 9){
			e.stopPropagation();
			e.preventDefault();
			if(e.altKey){
				this.props.handlePrev();
				this.nouSegment=1;
			}else{
				this.props.handleNext();
				this.nouSegment=1;
			}
			
		// FLETXA ( <-, -> ) + ALT
		//-------------------
		}else if( ((e.keyCode === 39)||(e.keyCode === 37)) && e.altKey){
			e.stopPropagation();
			e.preventDefault();
			this.deseleccionaTag();
			this.nextTipusSeg()
			
		// FLETXA v + ALT
		//-------------------
		}else if( (e.keyCode === 40) && e.altKey){
			e.stopPropagation();
			e.preventDefault();
			this.traspassaSegment();
		
		// ALT + ENTER
		//-------------------
		}else if((e.keyCode == 10 || e.keyCode == 13) && (e.ctrlKey || e.metaKey)){
			this.props.validaSegment(this.props.index);
		
		// DELETE (Evita eliminar TAGs)
		//-------------------
		}else if(e.keyCode === 46){
			if(this.indexTagSeleccionat > -1){
				e.stopPropagation();
				e.preventDefault();
			}else if(this.nameRef.current.selectionStart !== this.nameRef.current.selectionEnd){
				
			}else if(this.nameRef.current.selectionEnd<(this.nameRef.current.textLength+1) && (this.cercaTagEnPos(this.nameRef.current.value, this.nameRef.current.selectionStart+1)!=-1)){
				e.stopPropagation();
				e.preventDefault();
			}
		// BACKSPACE (Evita eliminar TAGs)
		//-------------------
		}else if(e.keyCode === 8){
			if(this.indexTagSeleccionat > -1){
				e.stopPropagation();
				e.preventDefault();
			}else if(this.nameRef.current.selectionStart !== this.nameRef.current.selectionEnd){
				
			}else if(this.nameRef.current.selectionStart>0 && (this.cercaTagEnPos(this.nameRef.current.value, this.nameRef.current.selectionStart-1)!=-1)){
				e.stopPropagation();
				e.preventDefault();
			}
		// SPACE (Recoloca caret quan es veuen caracters invisibles)
		//-------------------
		}else if((e.keyCode === 32) && this.props.showInvChars>0){
			//e.stopPropagation();
			e.preventDefault();
			//console.log(e.target);
			if ("selectionStart" in e.target && document.activeElement == e.target) {
					let start = e.target.selectionStart;
					let end = e.target.selectionEnd;
					this.caretPos = start;
					const newValue = e.target.value.substring(0, start) + "·" + e.target.value.substring(end);
					e.target.value=newValue;
					this.handleChange(e);
			}
		}else{
			this.deseleccionaTag();
		}
	}
	
	selectorTipusSegClick(e){
		this.setState({tipusSeg: e.target.className});
	}
	
	pintaSelectorTipusSeg(){
		var color;
		let lstTipus= new Array();
//		console.log("Tipus seg sel:"+this.state.tipusSeg);
		for (var key in this.props.segment) {
			//var value = array[key];
			switch(key){
				case "src":
					if(this.state.tipusSeg=="src"){
						color="#F00";
					}else{
						color="#001f3d";
					}
					lstTipus.push(<span class="src" style={{color: color, cursor: "pointer"}} onClick={this.selectorTipusSegClick}> [O] </span>);
														break;
				case "trg":
					if(this.state.tipusSeg=="trg"){
						color="#F00";
					}else{
						color="#001f3d";
					}
					lstTipus.push(<span class="trg" style={{color: color, cursor: "pointer"}} onClick={this.selectorTipusSegClick}> [T] </span>);
														break;
				case "ECL TMX":
					if(this.state.tipusSeg=="ECL TMX"){
						color="#F00";
					}else{
						color="#001f3d";
					}
					lstTipus.push(<span class="ECL TMX" style={{color: color, cursor: "pointer"}} onClick={this.selectorTipusSegClick}> [TM] </span>);
														break;
				case "ECL TA":
					if(this.state.tipusSeg=="ECL TA"){
						color="#F00";
					}else{
						color="#001f3d";
					}
					lstTipus.push(<span class="ECL TA" style={{color: color, cursor: "pointer"}} onClick={this.selectorTipusSegClick}> [TA] </span>);
														break;
			}
//			console.log("Tipus seg:"+key);
		}
		return lstTipus;
	}
	
	calMostrarTag(iTag){
		// Amaga el tag que arrastrem
		if(this.indexTagSeleccionat==iTag && this.arrastranTagFase>0){
			//console.log("amaga tag "+iTag+" perque lestem arrastrant");
			return false;
		}
		// Amaga tags extrems si estan simplificats i ho son tant en el src com en el trg
		if(this.props.simplificaTags && ( (this.props.segment["src"].tags[iTag].position==0 && this.props.segment["trg"].tags[iTag].position==0) || (this.props.segment["src"].tags[iTag].position==this.props.segment["src"].text.length && this.props.segment["trg"].tags[iTag].position==this.props.segment["trg"].text.length) )){
			//console.log("amaga tag "+iTag+" per simplificaTags");
			return false;
		}
		return true;
	}
	generaTextEditor(){
		let i=0;
		var tag;
		var esTag;
		let text=this.props.segment[this.state.tipusSeg].text;
		let textFinal="";
		
		let iText=0;
		let lstTagsTractats=this.props.segment["src"].tags.map(() => false);
//		console.log("text:"+text);
		//Coloca Tags en mig del text
		while(iText<(this.props.segment[this.state.tipusSeg].text.length+1)){
//			console.log("------------------------------------------------------------------------");
//			console.log("iText ["+iText+"/"+this.props.segment[this.state.tipusSeg].text.length+"]");
			for(let iTag=0; iTag<this.props.segment[this.state.tipusSeg].tags.length; iTag++){
//				console.log("iTag ["+iTag+"] :"+ lstTagsTractats[iTag] );
//				console.log(this.props.segment[this.state.tipusSeg].tags[iTag]);
				if(this.props.segment[this.state.tipusSeg].tags[iTag].position==iText){
					if(this.calMostrarTag(iTag)){
						textFinal+="<"+this.props.segment[this.state.tipusSeg].tags[iTag].code+">";
					}
					lstTagsTractats[iTag]=true;
//					console.log("textFinal_1:["+textFinal+"]");
				}
			}
			textFinal+=this.props.segment[this.state.tipusSeg].text.charAt(iText);
//			console.log("textFinal_2:["+textFinal+"]");
			iText++;
		}
		//Coloca Tags al final del text i els que falten al principi
		
		let tagsQueFalten="";
		for(let iTag=0; iTag<this.props.segment[this.state.tipusSeg].tags.length; iTag++){
//			console.log("iTag ["+iTag+"] :"+ lstTagsTractats[iTag] );
			if(!lstTagsTractats[iTag] && this.calMostrarTag(iTag)){
				//console.log("coloca tag "+iTag+" al principi, perque encara no havia estat tractat. Tocava: "+this.props.segment[this.state.tipusSeg].tags[iTag].position);
				//textFinal="<"+this.props.segment[this.state.tipusSeg].tags[iTag].code+">"+textFinal;
//				console.log("tracte ["+iTag+"]");
				tagsQueFalten+="<"+this.props.segment[this.state.tipusSeg].tags[iTag].code+">";
			}
		}
		
		if(this.nameRef!=null && this.nameRef.current!=null && (this.nameRef.current.selectionStart===this.nameRef.current.selectionEnd) ){
			textFinal = textFinal.slice(0, this.nameRef.current.selectionStart) + tagsQueFalten + textFinal.slice(this.nameRef.current.selectionStart);
		}
		
		if(this.props.showInvChars>0){
			textFinal=textFinal.replace(/ /g,"·");
			textFinal=textFinal.replace(/\t/g,'\u2192');
		}
		//console.log("generaTextEditor [textAmbTags]: "+textFinal);
		return textFinal;
	}
	
	render() {
		//console.log("Editor Segment RENDER;");
		//console.log(this.state);
		var w;
		var cpl;
		var ls;
		var fs="21px";
		let text=this.generaTextEditor();
		if(this.state.width>0 && text){
			w = (this.state.width/2.2);
			cpl = (w/11);
			ls = text.length/cpl;
		}else{
			ls=1;
		}
		let bgcolor = this.state.tipusSeg==="trg"?"#FFF": "#e5e8e8";
		//if(text.length>300){
		//	fs="16px";
		//}else{
		//	fs="21px";
		//}
		
		if(this.props.showInvChars>0 && this.caretPos>-1){
			if(!this.nameRef.current.setSelectionRange){
				var range = this.nameRef.current.createTextRange();
				range.collapse(true);
				range.moveEnd('character', this.caretPos);
				range.moveStart('character', this.caretPos);
				range.select();
				this.caretPos=-1;
			}else{
				this.nameRef.current.setSelectionRange(this.caretPos+1, this.caretPos+1);
				this.caretPos=-1;
			}
			
		}
		
		return (
					<Grid container item direction="row" justify="center" alignItems="center" xs={12} spacing={0}>
						<Grid item xs={12}>
							<div style={{ border: "1px solid #999999", margin: "5px 0", padding: "3px", height: "100%"}}>
								<textarea
									onKeyDown={this.handleKey}
									value={text}
									onChange={this.handleChange}
									onClick={this.handleClick}
									style={{width: "100%", fontSize: fs, backgroundColor: bgcolor, lineHeight: "1em" }}
									rows={ls+1}
									id={this.props.current}
									ref={this.nameRef}
									onDragEnter={this.onDragEnter}
									onSelect={this.onSelect}
								/>
							</div>
						</Grid>
					</Grid>
		);
	}
}

export default EditorSegments;